<!-- Botón flotante modo oscuro -->
<div class="theme-toggle" (click)="toggleDarkMode()" [class.dark]="isDarkMode" matTooltip="Modo Obscuro / Claro" matTooltipPosition="left">
  <i class="bi" [ngClass]="isDarkMode ? 'bi-moon-stars-fill' : 'bi-sun-fill'"></i>
</div>
<router-outlet />
